/*
This sets a cookie for every user that is logged in for the first time
If a user has this cookie, the Call To action Block (apply now!) are hidden
*/

(function ($, Drupal, once, cookies) {
  'use strict';

  Drupal.behaviors.calltoaction = {
    attach: function (context, settings) {

      let $isLoggedIn = $('body').hasClass('user-logged-in');
      if ($isLoggedIn && !cookies.get('calltoaction')) {
        cookies.set('calltoaction', 1, {expires: 100 * 365, path: '/'})
      }
      // Hide the Calltoaction block if user already has an account.
      $(once('calltoactiom-hide', '.call-to-action-block', context)).each(function () {
        $(this).each((index, el) => {
          if (cookies.get('calltoaction')) {
            $(el).hide();
          }
        });
      });

    }
  }
})(jQuery, Drupal, once, window.Cookies);
